export const errorExtract = (errors) => {
  let errorString = [];
  Object.keys(errors).forEach((item) =>
    Object.keys(errors[item]).forEach((item2) =>
      errorString.push(errors[item][item2])
    )
  );
  return errorString;
};
